import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/** This component scrolls the page to the top when the pathname changes. */
export const ScrollToTopOnPathnameChange = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        setTimeout(() => {
            window.scrollTo(0, 0);
            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
        }, 0);
    }, [pathname]);

    return null;
};
